import { COLOR_KEYS } from '../../../constants';
import { Props } from './TestimonialCarousel';

export const DEFAULT_VALUES: Props = {
  testimonials: new Array(3).fill({
    quote: 'This is a default quote (Edit me)',
    author: 'Name Surname',
    company: 'Zapier',
    hasAuthorAvatar: true,
    avatarUrl: 'https://cdn.zappy.app/5451454a0209e3d746a5f7c2f1a34aff.png',
    mediaURL: 'https://cdn.zappy.app/255f5477d911b5b66c44f8e1727df828.png',
  }),
  backgroundColor: COLOR_KEYS.cream,
};
